import api from 'api';

export const loadDepartments = api('GET /api/users/departments/grid');

export const createDepartments = api('POST /api/users/departments');

export const removeDepartments = api('DELETE /api/users/departments/:name');
